export const Citation = () => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g id="Icons" clipPath="url(#clip0_3128_12712)">
      <g id="Group 46">
        <rect id="Rectangle" x="0.509277" y="6.40753" width="18.8" height="23.6" rx="8.0504" fill="#018374" />
        <path
          id="Vector"
          d="M20.1667 2.40002H7.63333C5.90284 2.40002 4.5 3.93691 4.5 5.83275V22.5673C4.5 24.4631 5.90284 26 7.63333 26H20.1667C21.8972 26 23.3 24.4631 23.3 22.5673V5.83275C23.3 3.93691 21.8972 2.40002 20.1667 2.40002Z"
          fill="white"
          stroke="#018374"
          strokeLinecap="round"
        />
        <g id="Group 897">
          <path
            id="Path"
            d="M15.6998 4.40002H25.6048C26.083 4.40046 26.5413 4.60814 26.8785 4.97714C27.2156 5.34615 27.4038 5.84608 27.4014 6.36638V12.6783C27.4014 13.1972 27.2119 13.6948 26.8747 14.0617C26.5375 14.4286 26.0801 14.6347 25.6032 14.6347H22.8603C21.6778 14.6347 21.6961 15.4637 21.6961 17.1068C21.6961 18.7498 20.2393 15.8169 19.7822 15.2797C19.4403 14.8701 18.9558 14.636 18.4473 14.6347H15.7044C15.2264 14.6365 14.7675 14.4311 14.429 14.064C14.0904 13.697 13.9002 13.1983 13.9002 12.6783V6.36638C13.8981 5.84564 14.0868 5.34546 14.4246 4.97646C14.7623 4.60745 15.2212 4.40002 15.6998 4.40002Z"
            fill="white"
            stroke="#018374"
          />
          <path
            id="Path_2"
            d="M22.6017 9.95056H12.6978C11.7049 9.95056 10.8999 10.8264 10.8999 11.9069V18.2268C10.8995 18.746 11.0887 19.244 11.426 19.6112C11.7632 19.9785 12.2207 20.1848 12.6978 20.1848H13.8939C15.0763 20.1848 15.058 21.0138 15.058 22.6567C15.058 24.2997 16.5253 21.3719 16.9839 20.833C17.3257 20.4235 17.8102 20.1894 18.3187 20.1881H22.6017C23.5955 20.1881 24.4011 19.3115 24.4011 18.2301V11.9069C24.4011 11.3878 24.2115 10.8899 23.874 10.523C23.5365 10.156 23.0788 9.95012 22.6017 9.95056Z"
            fill="white"
            stroke="#018374"
          />
          <g id="Path_3">
            <path
              d="M22.5974 9.95058H13.7502V12.5755C13.7502 13.6801 14.5544 14.5756 15.5464 14.5756H18.2841C18.7932 14.5755 19.2787 14.8147 19.621 15.2344C20.0773 15.7882 21.5434 18.7704 21.5434 17.0972C21.5434 15.424 21.5252 14.5722 22.7054 14.5722H24.4012V11.9506C24.4012 11.4187 24.2109 10.9087 23.8724 10.5334C23.5339 10.1581 23.0751 9.94833 22.5974 9.95058Z"
              fill="#87E8D1"
            />
          </g>
          <path
            id="Path_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.6017 9.95056H12.6978C11.7049 9.95056 10.8999 10.8264 10.8999 11.9069V18.2268C10.8995 18.746 11.0887 19.244 11.426 19.6112C11.7632 19.9785 12.2207 20.1848 12.6978 20.1848H13.8939C15.0763 20.1848 15.058 21.0138 15.058 22.6567C15.058 24.2997 16.5253 21.3719 16.9839 20.833C17.3257 20.4235 17.8102 20.1894 18.3187 20.1881H22.6017C23.5955 20.1881 24.4011 19.3115 24.4011 18.2301V11.9069C24.4011 11.3878 24.2115 10.8899 23.874 10.523C23.5365 10.156 23.0788 9.95012 22.6017 9.95056Z"
            stroke="#018374"
            strokeWidth="0.416054"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3128_12712">
        <rect width="30" height="30" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
